import { t } from '@lingui/core/macro';

import ChevronLeftIcon from '@/assets/svg/bx-chevron-left.svg?react';
import { cn } from '@/lib/utils';

import PaginationLink, { type PaginationLinkProps } from './PaginationLink';

export type PaginationPreviousProps = PaginationLinkProps;

const PaginationPrevious = ({ className, ...props }: PaginationPreviousProps) => {
  return (
    <PaginationLink aria-label={t`Go to previous page`} className={cn(className)} {...props}>
      <ChevronLeftIcon data-icon="inline-start" className="rtl:-scale-x-100" />
    </PaginationLink>
  );
};

export default PaginationPrevious;
